import React, { useEffect } from 'react';

export default function AdsCard({ path, client, slot, layoutKey, format, fullWidth }) {
    useEffect(() => {
        if (window.adsbygoogle && process.env.NODE_ENV !== "development") {
            try {
                window.adsbygoogle.push({});
            } catch (err) {
                console.error("google adsenseが正しく設置されていないようです。" + err)
                return (<></>)
            }
        }
    }, [path])

    const styleData = {
        "display": "block",
    }

    return (
        <ins className="adsbygoogle"
            id="ad_ins"
            style={styleData}
            data-ad-client={client || process.env.GOOGLE_AD_CLIENT}
            data-ad-slot={slot || process.env.GOOGLE_AD_SLOT1}
            data-ad-format={format || "auto"}
            data-ad-layout-key={layoutKey || ""}
            data-full-width-responsive={fullWidth || "true"}></ins>
    );
}